// Endpoint
export const TumHrmEndpoint = {
  GET_TUM_HRM: 'tum-hrm',
  SEARCH_TUM_HRM: 'tum-hrm/search',
  TUM_HRM_SAVE_MANY: 'tum-hrm/save-many',
  UPDATE_TUM_HRM: 'tum-hrm/update',
  UPDATE_IS_SYNC_TUM_HRM_MANY: 'tum-hrm/update-is-sync-many',
  UPDATE_IS_SYNC_TUM_HRM_ALL: 'tum-hrm/update-is-sync-all',
  GET_TUM_HRM_IS_SYNC: 'tum-hrm/is-sync',
  EXPORT_HRM: 'tum-hrm/download',
}
